import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from '../../app/bento-components/video-list/video-list-cta.scss';
import { DEFAULT_CTA } from '../../app/bento-components/video-list/metadata';

class VideoListCTA extends Component {
    static propTypes = {
        videoId: PropTypes.string,
        showId: PropTypes.string,
				isShowCTAAvailable: PropTypes.bool.isRequired,
        cta: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            target: PropTypes.string
        }).isRequired
    }

    render() {
			const { cta: {text, url, target}, videoId, showId, isPillButtonAvailable, isShowCTAAvailable } = this.props;
			const linkText = text || DEFAULT_CTA.text || DEFAULT_CTA.textPlaceholder;
			const linkUrl = url || DEFAULT_CTA.link.url;
			const linkTarget = target || DEFAULT_CTA.link.target;
			if (!url || url === '#') {
					return null;
			}

			if (!videoId && !showId) {
					return <div className={`video-cta shape-placeholder ${styles.videoCTA}`} />;
			}

			let pillButtonComponent = isPillButtonAvailable ? 'pill-button-component' : '';
			let ctaClass = isShowCTAAvailable ? 'show-cta' : 'video-cta';

			return (
            <a
                className={`${ctaClass} ${styles.videoCTA} ${pillButtonComponent}`}
                href={linkUrl}
                target={linkTarget}
                aria-label={`${linkText}${linkTarget === '_blank' ? ' (opens in new window)' : ''}`}
                {...(linkTarget === '_blank' ? { rel: 'noopener noreferrer' } : {})}>
                {linkText}
            </a>
        );
    }
}

export default VideoListCTA;
